import { NgModule } from '@angular/core';
import { ScrollbarModule } from 'ngx-scrollbar';

import { FlexLayoutModule } from "@angular/flex-layout";
import { AppLayoutRoutingModule } from './app-layout-routing.module';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CommonsModule } from '../commons/commons.module';
import { MenuComponent } from './menu/menu.component';
import { AuthModule } from '../auth/auth.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BreadCrumbComponent } from './bread-crumb/bread-crumb.component';
// import { NotificationsComponent } from '../notifications/notifications.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';
import { TourNgBootstrapModule } from 'ngx-tour-ng-bootstrap';



@NgModule({
  imports: [
    AppLayoutRoutingModule,
    FlexLayoutModule,
    CommonsModule,
    AuthModule,
    NgbModule,
    ScrollbarModule,
    TourNgBootstrapModule
  ],
  exports:[MenuComponent,BreadCrumbComponent],
  declarations: [
    LayoutComponent,
     HeaderComponent, 
     SidebarComponent,
      MenuComponent, 
      BreadCrumbComponent,
      // NotificationsComponent,
      SubMenuComponent
    ]
})
export class AppLayoutModule { }
